import { useEffect, useState } from 'react';
import { isAppVisible } from '@mews/std';

export const useAppVisibility = () => {
    const [appVisible, setAppVisible] = useState(isAppVisible());
    useEffect(() => {
        const handleVisibilityChange = () => {
            setAppVisible(isAppVisible());
        };
        window.document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            window.document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    return appVisible;
};
